import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import ChangePassword from "./components/ChangePassword";
import Navbar from "./components/Navbar";
import OrderManager from "./components/OrderManager";
import Footer from "./components/Footer";

function App() {
  // Initialize user state from localStorage
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  // View state: 'login', 'forgot-password', 'orders', 'change-password'
  const [currentView, setCurrentView] = useState('login');

  const handleLogin = (userData) => {
    setUser(userData);
    // Save user data to localStorage
    localStorage.setItem('user', JSON.stringify(userData));
    setCurrentView('orders');
  };

  const handleLogout = () => {
    setUser(null);
    // Remove user data from localStorage
    localStorage.removeItem('user');
    setCurrentView('login');
  };

  const handleForgotPassword = () => {
    setCurrentView('forgot-password');
  };

  const handleBackToLogin = () => {
    setCurrentView('login');
  };

  const handleChangePassword = () => {
    setCurrentView('change-password');
  };

  const handleBackToOrders = () => {
    setCurrentView('orders');
  };

  return (
    <div>
      {!user ? (
        <>
          {currentView === 'login' ? (
            <Login onLogin={handleLogin} onForgotPassword={handleForgotPassword} />
          ) : (
            <ForgotPassword onBackToLogin={handleBackToLogin} />
          )}
        </>
      ) : (
        <>
          <Navbar
            user={user}
            onLogout={handleLogout}
            onChangePassword={handleChangePassword}
          />
          {currentView === 'change-password' ? (
            <ChangePassword user={user} onBack={handleBackToOrders} />
          ) : (
            <OrderManager />
          )}
        </>
      )}
      <Footer />
    </div>
  );
}

export default App;
